/// <amd-module name="Wit/Common/Constants/DataProviders" />
export namespace DataProviders {
    export const TeamContextDataProvider = "ms.vss-tfs-web.team-context-data-provider";
}
